/**
 * Created by tpetridis on 7/2/2017.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common/index';
import game from './modules/game/index';
import i18n from './modules/i18n/index';
import profile from './modules/profile/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    game,
    i18n,
    profile,
  },
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js